(() => {
  if (customElements.get('broek-home-reviews')) return;

  class BroekHomeReviews extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.refreshReviews();
    }

    plainText(value) {
      return new DOMParser().parseFromString(String(value || ''), 'text/html')
        .body.textContent.replace(/\s+/g, ' ').trim();
    }

    element(tag, className, text) {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    }

    card(review) {
      const card = this.element('article', 'bh-review-card');
      card.setAttribute('role', 'listitem');
      card.dataset.reviewId = review.uuid;
      const rating = Math.round(Number(review.rating));
      const stars = this.element('div', 'bh-review-stars', '★'.repeat(rating) + '☆'.repeat(5 - rating));
      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', rating + ' out of 5 stars');
      const details = this.element('details', 'bh-review-content');
      const summary = this.element('summary');
      const excerpt = this.element('span', 'bh-review-excerpt', review.text);
      excerpt.dir = 'auto';
      summary.append(excerpt, this.element('span', 'bh-review-more', 'Read more'), this.element('span', 'bh-review-less', 'Show less'));
      const full = this.element('p', 'bh-review-full', review.text);
      full.dir = 'auto';
      details.append(summary, full);
      const meta = this.element('div', 'bh-review-meta');
      meta.append(this.element('strong', '', review.reviewer_name || 'Customer'));
      let product = this.element('span', '', review.product_title || 'BROEK');
      try {
        const target = new URL(review.product_url, this.dataset.storeUrl);
        const store = new URL(this.dataset.storeUrl);
        if (target.hostname === store.hostname && /^\/products\/[a-z0-9-]+\/?$/i.test(target.pathname)) {
          product = this.element('a', '', review.product_title);
          product.href = target.pathname + '#judgeme_product_reviews';
        }
      } catch (_) {}
      meta.append(product);
      card.append(stars, details, meta);
      return card;
    }

    async refreshReviews() {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 12000);
      try {
        // Same public, published-review endpoint used by the installed Judge.me carousel.
        const params = new URLSearchParams({
          reviews_selection: 'all', carousel_type: 'cards', star_rating: '4_to_5_star',
          max_reviews: '30', url: this.dataset.storeUrl, shop_domain: this.dataset.shopDomain,
          platform: 'shopify', primary_language: document.documentElement.lang || 'en',
          display_order: 'most_recent'
        });
        const response = await fetch('https://cdn.judge.me/reviews/reviews_for_carousel?' + params, { signal: controller.signal });
        if (!response.ok) throw new Error('Review source unavailable');
        const payload = await response.json();
        const seen = new Set();
        const reviews = (Array.isArray(payload.reviews) ? payload.reviews : [])
          .map(review => ({ ...review, text: this.plainText(review.body_html), reviewer_name: this.plainText(review.reviewer_name), product_title: this.plainText(review.product_title) }))
          .filter(review => {
            const letters = review.text.match(/[\p{L}\p{N}]/gu) || [];
            if (!review.uuid || seen.has(review.uuid) || letters.length < 20 || !Number.isFinite(Number(review.rating)) || Number(review.rating) < 4 || Number(review.rating) > 5) return false;
            seen.add(review.uuid);
            return true;
          })
          .sort((a, b) => (Date.parse(b.created_at) || 0) - (Date.parse(a.created_at) || 0))
          .slice(0, 4);
        // Retain the existing genuine review cards if the source has too little usable text.
        if (!this.isConnected || reviews.length < 3) return;
        const track = this.querySelector('.bh-reviews-track');
        if (!track) return;
        track.replaceChildren(...reviews.map(review => this.card(review)));
        this.dataset.sourceState = 'judgeme';
        this.dataset.reviewCount = String(reviews.length);
      } catch (_) {
        this.dataset.sourceState = 'fallback';
      } finally {
        clearTimeout(timeout);
      }
    }
  }
  customElements.define('broek-home-reviews', BroekHomeReviews);
})();
